import { render, staticRenderFns } from "./SlcShareSearchButton.vue?vue&type=template&id=473d2fc8&"
import script from "./SlcShareSearchButton.vue?vue&type=script&lang=ts&"
export * from "./SlcShareSearchButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports